// WFTASKS: a workflow step done by a person is also a task ("workflow_step") for its assignee.
//
// ONE PLACE for what every task list does with it:
//   * opening it goes to that workflow instance, opened, through the same /open/workflow/<id> link
//     the workflow_step_assigned email button uses (emailLinks.js picks the page for the role);
//   * "Mark complete" calls the generic task endpoint, which completes the STEP on the server with
//     the workflow screen's own checks. A step that needs a file or a form is refused with
//     NEEDS_INPUT_DETAIL, and the step is opened instead so the person can attach or fill it there.
// The title comes from the server in English and French (title / title_fr), like every task.
import axios from 'axios';
import { OPEN_BASE } from './emailLinks';

export const WORKFLOW_STEP_TASK_TYPE = 'workflow_step';
export const NEEDS_INPUT_DETAIL = 'This step needs a file or a form. Open it to complete it.';

export function isWorkflowStepTask(task) {
  return Boolean(task) && task.task_type === WORKFLOW_STEP_TASK_TYPE;
}

// The workflow instance id carried by the task's link ("/workflows/<id>"), or null.
export function workflowInstanceId(task) {
  const link = (task && task.link_url) || '';
  const m = /^\/workflows\/([A-Za-z0-9_-]{1,64})(?:[?#].*)?$/.exec(link);
  return m ? m[1] : null;
}

// Where opening the task goes: that instance, or the role's workflow list when the id is unknown.
export function workflowStepOpenPath(task) {
  const id = workflowInstanceId(task);
  return id ? `${OPEN_BASE}/workflow/${id}` : `${OPEN_BASE}/workflows`;
}

// Completes the task (and so the step). Resolves 'completed', or 'opened' after calling open()
// when the step needs a file or a form. Any other refusal is thrown, for the caller's error state.
export async function completeWorkflowStepTask(api, task, open) {
  try {
    await axios.patch(`${api}/dashboard/tasks/${task.task_id || task.id}/complete`);
    return 'completed';
  } catch (err) {
    if (err?.response?.status === 409 && err?.response?.data?.detail === NEEDS_INPUT_DETAIL) {
      if (typeof open === 'function') open(workflowStepOpenPath(task));
      return 'opened';
    }
    throw err;
  }
}
